<template>
  <div id="app">
    <div class="header_wrap_new sticky-header postlogin-24112020-header">
      <header class="header">
        <!-- <div id="nav-icon">
          <span></span>
          <span></span>
          <span></span>
        </div> -->
        <!-- RummyCircle Logo Desktop Header Starts -->
        <div class="logo desktopHeaderLogo">
          <a href="" tppabs="https://www.rummycircle.com/">
            <img src="../src/assets/images/icon-Wingo.png" style="width: 57px;;"  alt=""
              title="" /></a>
        </div>
        <!-- RummyCircle Logo Desktop Header Ends -->
        <div class="rummycircle-app-disable-common">
          <div class="comminityTxt">WINWINGOKE GAME</div>
          <div class="fusion_header_players_box lazy" data-src="../../rcmg.in/rc/landingpage-icon-css-sprite-6.jpg"
            tppabs="https://rcmg.in/rc/landingpage-icon-css-sprite-6.jpg">
            <div class="fusion_header_players_heading">10,000,000+</div>
            <div>Players</div>
          </div>

          <ul class="headerButton">
            <li  @click="ToIndex()">
              <div class="text">Don't have an Account yet?</div>
              <a class="btn_primary btn-register" :href="url"
                tppabs="https://www.rummycircle.com/?utm_source=organic&utm_medium=registraion&utm_content=innerpage"
                title="Register for Free">Register for Free</a>
            </li>
            <li><span>Already a Member?</span> <a :href="url" title="login">Login</a>
            </li>
          </ul>
        </div>
      </header>
    </div>
    <div class="mainContainer pt-110 postlogin-24112020-remove-whiteSpace">


      <div class="main_head"></div>
      <div class="ca_wrap">

        <input type="hidden" name="pageName" id="pageName" value="download-rummy.html">
        <input type="hidden" id="fromPage" value="download-rummy.html">

        <div class="main_content">
          <h1 class="ca_head">Download WINGOKE Official Authorized APP: Amazing Wheel</h1>
          <div class="content_area">
            <div class="imgCaption">
              <img class="img-responsive" src="../src/assets/images/main.jpg"
                tppabs="https://rcmg.in/rc/acquisition/how-to-play-rummy-page-images/hrithik-roshan-banner-680by380.jpg"
                width="680" height="380" alt="Download Rummy Game App" />
              <br><br>
            </div>
            <p>Hey Guys,now let's experience the same 777bet excitement on your mobile.
              Download the Wingoke Official authorized Google Play App- Amazing Wheel for FREE on your Android for fast,
              secure & seamless app experience of games on your mobile and enjoy favourite Lucky Spins,
              Slots,Crash,Mines,PLINKO,DICE,etc.

            </p>
            <p>So, how to download the game on your Android device? Just follow these 3 easy steps:</p>

            <div class="imgCaption"  @click="ToIndex()">
              <a :href="appurl" ><img
                  class="img-responsive lazy" width="767" height="473" alt="Get It On Google Play"
                  src="../src/assets/images/down.jpg" id="seopages-content-googleplaystore-apk-download"
                  style="display: inline; overflow: hidden;"></a>
            </div>

            <p class="col-xs-12"><strong>Step 1</strong> – Click the “Get it On Google Play Button”Download Amazing Wheel on
              Google play.</p>

            <p class="col-xs-12"><strong>Step 2</strong> – Click on the Install button to install the app on your phone.
            </p>

            <p class="col-xs-12"><strong>Step 3</strong> – Open the app and Register for free</p>


            <p class="clearing"></p>
            <p style="font-size:12px; text-align:justify;">New player will enjoy register bouns, and first deposit
              bonus.</p>

            <p>Wingoke is committed to provide Game Experience to all its players. With our sleek and fast Android & IOS
              App, you can now play online Wingoke games for cash from anywhere and anytime.</p>
            <p>Now that you have this super cool app installed, it's time to try it out.</p>
            <h3 class="sub_head4"><strong>New Player</strong></h3>
            <br>
            <p>Playing with Amazing Wheel-Wingoke Game for the first time? Well, you just made a great start! To play
              Wingoke Game, you need to be very focused and use your skill at the same time. Now, open your recently
              downloaded Android to register with us and start playing real money/cash games/tournaments or simply start
              playing DEMO sessions right away. If you are still getting the hang of the game, then simply experience
              how to play Wingoke Game in practice games before trying the real money or the cash games. Click here
              “DEMO” section to understand the game rules and play better.
            </p>
            <h3 class="sub_head4"><strong>Existing Player</strong></h3>

            <p>
              If you are already registered with us, just open your recently downloaded Android and log in with your
              account id and password and enjoy playing Wingoke Game on your mobile.Usually, account id is your phone
              number without your country code. If you have any problem about register,log in or cash in or out, please
              contact our player support. https://t.me/Wingoke
            </p>

            <h2 class="sub_head noAfter">What are the benefits of downloading Wingoke Official authorized Google Play
              App- Amazing Wheel
            </h2>
            <h3 class="sub_head4"><strong>FASTER & SMOOTHER EXPERIENCE</strong></h3>
            <p>App is sleek, smooth and fast. The user interface is clean and loads the game quickly. What you
              experience when you play games is the clean game table, dashboard to pick games and manage your account.
            </p>
            <h3 class="sub_head4"><strong>YOUR FAVORITE GAME FORMAT ON THE GO!</strong></h3>
            <p>With the rummy app, the game is now in your palm. It's easy to use, and it's very convenient. After all,
              what can be handier than a cool game in your pocket! If you’ve ever played slots games, this will be a
              breeze for you!</p>
            <h3 class="sub_head4"><strong>SPECIAL PROMOTIONS</strong></h3>
            <p>There are special offers and promotions running all the time. If you want to make the most of it, then
              just enjoy the game on the Android and never miss a deal.</p>
            <h3 class="sub_head4"><strong>REAL TIME UPDATES</strong></h3>
            <p>And, just so you don’t miss out on any special offers or the opportunity to win real money or cash
              prizes, we give you real-time alerts on the app.</p>
            <h3 class="sub_head4"><strong>NO DISTRACTIONS</strong></h3>
            <p>Packed with rich colours, seamless user interface and the option to play multi-table games at the same
              time.
              <br>So, download the app for free on Android witness the best game experience get even better-also, win
              real cash !
            </p>

          </div>
        </div>
      </div><!--/ca_wrap-->
    </div><!--/content_wrap-->

    <footer class="footer postlogin-24112020-footer">
      <div class="footer_home">
        <div class="col_home1">
          <!-- RummyCircle Logo Desktop Footer Starts -->
          <div class="col_home_fot_logo">
            <img class="lazy" src="../src/assets/images/icon-Wingo.png" style="width: 57px;" width="298" height="57"
              alt="" id="footer_logo" />
          </div>
          <!-- RummyCircle Logo Desktop Footer Ends -->
          <p>GAME GUYS LIMITED T/A GAME GUYS CASINO, the proprietor and operator of this website islicensed& authorized by the Betting, Lotteries and Gaming Act, 1966 of The Republic of Kenya withRegistration NO.0000356.</p>

          <!-- <div class="sm_icons">
          <span>Follow Us On: </span>
          <a class="ico_fb lazy" data-src="../../rcmg.in/rc/acquisition/landingpage-icon-css-sprite-7.jpg"
            tppabs="https://rcmg.in/rc/acquisition/landingpage-icon-css-sprite-7.jpg"
            href="" title="Facebook" target="_blank"></a>
          <a class="ico_twit lazy" data-src="../../rcmg.in/rc/acquisition/landingpage-icon-css-sprite-7.jpg"
            tppabs="https://rcmg.in/rc/acquisition/landingpage-icon-css-sprite-7.jpg"
            href="" title="Twitter" target="_blank"></a>
          <a class="ico_insta lazy" data-src="../../rcmg.in/rc/acquisition/landingpage-icon-css-sprite-7.jpg"
            tppabs="https://rcmg.in/rc/acquisition/landingpage-icon-css-sprite-7.jpg"
            href="" title="Instagram" target="_blank"></a>
          <a class="ico_tele lazy" data-src="../../rcmg.in/rc/acquisition/landingpage-icon-css-sprite-7.jpg"
            tppabs="https://rcmg.in/rc/acquisition/landingpage-icon-css-sprite-7.jpg"
            href=""
             title="Telegram" target="_blank"></a>
        </div> -->
        </div>
        <div class="col_home2">
          <h6 class="footer_head">Quick Links</h6>
          <ul class="col2_links">
            <li @click="ToIndex()"><a :href="url" title="Wingoke Game Official Site">Wingoke Game Official Site</a></li>
          </ul>
          <!-- <ul class="col2_links">
            <li><a href="" tppabs="https://apps.apple.com/in/app/rummycircle-play-indian-rummy/id1434729714"
                target="_blank" title="Rummy on iOS">Rummy on iOS</a></li>
          </ul> -->
        </div>
        <div class="col_home3">
          <h6 class="footer_head">Security & Game Integrity</h6>
          <div class="scrollBar">
            <ul class="payment_part_foot">
              <li> <img class="" src="../src/assets/images/18.png" width="74" height="38" alt="18" /></li>
              <li> <img class="" src="../src/assets/images/Fraud-Control.png" width="74" height="38" alt="Fraud-Control" /></li>
              <li> <img class="" src="../src/assets/images/legal-Secure.png" width="74" height="38" alt="legal-Secure" /></li>
              <li> <img class="" src="../src/assets/images/no-bot-certified-icon.png" width="74" height="38" alt="No Bot" /></li>
              <li> <img class="" src="../src/assets/images/responsible-play.png" width="74" height="38" alt="responsible-play" /></li>
            </ul>
          </div>

        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import '../src/css/index.css'
export default {
  data() {
    return {
      url: window.$url,
      appurl:window.$appurl
    };
  },
  components: {},
  created() {
    let param = window.location.search.replace("?", "&");
    this.url+=param;
  },
  methods: {
    ToIndex() {
      let param = window.location.search.replace("?", "&");
      let oInput = document.createElement("input");
      oInput.value = param;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      oInput.style.display = "none";
      oInput.remove();
      console.log(param)
      // window.location.href =  window.$url;
    }
  },
};
</script>

<style lang="less">
// html,
// body {
//   height: 100%;
//   width: 100%;
//   margin: 0;
//   padding: 0;
// }

// #app {
//   height: 100%;
//   width: 100%;

//   a {
//     text-decoration: none;
//     -webkit-tap-heighlight-color: transparent;
//     outline: none;

//     :active {
//       text-decoration: none;
//     }
//   }

//   img {
//     width: 100%;
//   }

// }
</style>


// WEBPACK FOOTER //
// src/App.vue